import { CoreIcon } from '../core-icon';
import licensePlateFillSVG from '../../assets/icons/license-plate-fill.svg';
import type { IconProps } from '../core-icon';

export const LicensePlateFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={licensePlateFillSVG} {...props} />;
};
